import MdTooltip from "./MdTooltip"

const MdTooltipPlugin = {
  install(app) {
    app.component(MdTooltip.name, MdTooltip)
  },
}

export default MdTooltipPlugin
